module.exports = __webpack_public_path__ + "static/black-friday-c0119fab0d3f5dbd6debdd8b1f42bd2c.png";